export default __webpack_public_path__ + "static/media/result_body_underweight.05aa2106.jpg";